import _ from 'lodash';
import PropTypes from 'prop-types';
/* eslint new-cap: ["error", { "capIsNewExceptions": ["HOC"] }] */
import React from 'react';
import Textarea from 'react-textarea-autosize';
import formsyProps from '../FormsyProps';
import { HOC } from 'formsy-react';
import styles from '../CardField/CardField.scss';

const TextArea = class TextArea extends React.Component {
  static propTypes = {
    onBlur: PropTypes.func,
    setValue: PropTypes.func,
    getValue: PropTypes.func,
    onChange: PropTypes.func,
    showError: PropTypes.func,
    hasValue: PropTypes.func,
    validationError: PropTypes.string,
    required: PropTypes.bool,
    submitted: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.state = {
      initialBlur: false
    };
  }

  componentWillUnmount() {
    if (document && document.activeElement) {
      document.activeElement.blur();
    }
  }

  onBlur(e) {
    this.setState({ initialBlur: true });
    if (this.props.onBlur) this.props.onBlur(e);
  }

  changeValue(e) {
    this.props.setValue(e.target.value);
    this.props.onChange(e);
  }

  render() {
    const { showError, hasValue, validationError } = this.props;
    const hasError =
      (this.state.initialBlur || this.props.submitted) &&
      (showError() || (this.props.required && !hasValue()));
    const errorMessage = hasError ? validationError : null;
    const _rest = _.omit(this.props, formsyProps);

    return (
      <div>
        <Textarea
          {..._rest}
          onChange={this.changeValue}
          onBlur={this.onBlur}
          value={this.props.getValue()}
        />
        <div className={styles.errorMessage}>
          {errorMessage}
        </div>
      </div>
    );
  }
};

export default HOC(TextArea);



// WEBPACK FOOTER //
// ./webpack/components/Elements/TextArea/TextArea.js